import { Component, OnInit, Input } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Docente } from 'src/app/models/didattica/docente';

@Component({
    selector: 'app-info-docente',
    templateUrl: './info-docente.component.html',
    styleUrls: ['./info-docente.component.scss'],
    standalone: false
})
export class InfoDocenteComponent implements OnInit {
  @Input() infoDocente: boolean;
  @Input() docente: Docente;
  @Input() isPta: boolean;

  constructor(
    private navCtrl: NavController
  ) {}

  ngOnInit() {
    console.log('ngOnInit', this.docente);
  }

  gotoNewRil() {
    if(this.isPta) {
      this.navCtrl.navigateForward('insegnamenti');
    }
  }
}